import * as React from "react";
import { BaseSVG } from "../../BaseSVG";

export const StopIconSmall = props => (
  <BaseSVG viewBox="0 0 24 24" {...props}>
    <rect width="20" height="20" x="2" y="2" rx="1" />
  </BaseSVG>
);
